import { Routes } from '@angular/router';
import { authGuard } from './core/auth.guard';
import { sessaoGuard } from './core/sessao.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'sessao',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./sessao/sessao.component').then((m) => m.SessaoComponent),
  },
  {
    path: 'lista',
    canActivate: [authGuard, sessaoGuard],
    loadComponent: () =>
      import('./lista/lista.component').then((m) => m.ListaComponent),
  },
  {
    path: 'acompanhamento',
    canActivate: [authGuard, sessaoGuard],
    loadComponent: () =>
      import('./acompanhamento/acompanhamento.component').then(
        (m) => m.AcompanhamentoComponent,
      ),
  },
  {
    path: 'cadastro',
    canActivate: [authGuard, sessaoGuard],
    loadComponent: () =>
      import('./cadastro/cadastro.component').then((m) => m.CadastroComponent),
  },
  {
    path: 'cadastro/:id',
    canActivate: [authGuard, sessaoGuard],
    loadComponent: () =>
      import('./cadastro/cadastro.component').then((m) => m.CadastroComponent),
  },
  { path: '', pathMatch: 'full', redirectTo: 'lista' },
  { path: '**', redirectTo: 'lista' },
];
